/**
 * Formats seconds into a time string (m:ss or h:mm:ss)
 * @param seconds - Time in seconds
 * @param forceHours - Whether to always show hours
 * @returns Formatted time string
 */
export const formatTime = (seconds: number, forceHours = false): string => {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return '0:00';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0 || forceHours) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Parses a time string into seconds
 * @param timeString - Time string in format m:ss or h:mm:ss
 * @returns Time in seconds
 */
export const parseTime = (timeString: string): number => {
  const parts = timeString.split(':').map(Number);

  if (parts.some(isNaN)) {
    return 0;
  }

  if (parts.length === 3) {
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }

  if (parts.length === 2) {
    const [minutes, seconds] = parts;
    return minutes * 60 + seconds;
  }

  return 0;
};

/**
 * Calculates remaining time
 * @param currentTime - Current playback position in seconds
 * @param duration - Total duration in seconds
 * @returns Remaining time in seconds
 */
export const getRemainingTime = (currentTime: number, duration: number): number => {
  return Math.max(0, duration - currentTime);
};
